(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pc-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pc-hero-carrossel')) {
    class PcHeroCarrossel extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.pontos = [...this.querySelectorAll('[data-ir]')];
        this.atual = 0;
        if (this.slides.length < 2) return;
        this.querySelectorAll('[data-passo]').forEach((b) =>
          b.addEventListener('click', () => this.ir(this.atual + Number(b.dataset.passo), true))
        );
        this.pontos.forEach((b) => b.addEventListener('click', () => this.ir(Number(b.dataset.ir), true)));
        this.pausado = false;
        const pausar = () => (this.pausado = true);
        const seguir = () => (this.pausado = false);
        this.addEventListener('mouseenter', pausar);
        this.addEventListener('mouseleave', seguir);
        this.addEventListener('focusin', pausar);
        this.addEventListener('focusout', seguir);
        const reduzido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const intervalo = Number(this.dataset.intervalo) || 6000;
        if (!reduzido && intervalo > 0) {
          this.timer = setInterval(() => {
            if (!this.pausado && !document.hidden) this.ir(this.atual + 1, false);
          }, intervalo);
        }
      }
      disconnectedCallback() {
        clearInterval(this.timer);
      }
      ir(indice, peloUsuario) {
        const total = this.slides.length;
        const novo = ((indice % total) + total) % total;
        this.slides[this.atual].hidden = true;
        this.slides[novo].hidden = false;
        this.pontos.forEach((p, i) => (i === novo ? p.setAttribute('aria-current', 'true') : p.removeAttribute('aria-current')));
        this.atual = novo;
        if (peloUsuario) this.pausado = true;
      }
    }
    customElements.define('pc-hero-carrossel', PcHeroCarrossel);
  }

  } catch(e) { console.error(e); }
})();
})();
